<template>
  <div :class="isClass?'on':'nav'">
    <p> {{ label }} </p>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    isClass: {
      type: Boolean,
      default: true
    }
  }
}

</script>
<style lang='less' scoped>
.nav,.on{
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    cursor: default;
    p{
      height: 100%;
      margin: 0;
      line-height: 40px;
      border-bottom: 3px solid #1890ff;
      font-size: 16px;
      font-weight: 700;
    }

  }
  .on{
    border-bottom: 1px solid #ccc;
  }
</style>
